<template>
  <div class="login-wrap">
    <div class="login-navbar">
      <div class="logo"></div>
    </div>
    <div class="login">
      <h2 class="text-center mb-5">ADATA CMS</h2>
      <!-- account -->
      <div class="mb-5">
        <label for="account" class="d-block mb-1"><h5>帳號</h5></label>
        <div class="form-input-group">
          <input type="text" id="account" v-model="details.username" />
        </div>
      </div>
      <!-- password -->
      <div class="mb-4">
        <label for="password" class="d-block mb-1"><h5>Password</h5></label>
        <div class="form-input-group">
          <input id="password"
                 v-model="details.password"
                 :type="showPassword ? 'text' : 'password'" />
          <div
            class="append-icon"
            @click="showPassword = !showPassword"
            style="cursor: pointer;"
          >
            <v-icon v-if="showPassword == false" key="visibility">
              visibility
            </v-icon>
            <v-icon v-if="showPassword == true" key="visibility_off">
              visibility_off
            </v-icon>
          </div>
        </div>
      </div>
      <!-- keep login -->
      <div class="mb-3">
        <v-checkbox>
          <template v-slot:label>
            <div class="h5 ink-01-emphasis--text">保持登入</div>
          </template>
        </v-checkbox>
      </div>
      <!-- login -->
      <div>
        <button class="btn btn-primary w-100" @click="loginUser">登入</button>
      </div>
      <div class="h5 ink-01-emphasis--text"> <a href="https://beian.miit.gov.cn/" target="_blank" > 苏ICP备16044365号-6 <a></div>
      <div class="h5 ink-01-emphasis--text">  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002004066" target="_blank" > <img  src="/icon/cn_icp_icon.png">苏公网安备 32059002004066号 </a></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    showPassword: false,
    details: {
      username: '',
      password: '',
    },
  }),
  methods: {
    ...mapActions(['login']),
    loginUser() {
      return this.login(this.details)
        .then(() => this.$router.push('/'))
        .catch((error) => {
          console.log(error);
          this.$store.dispatch('notifications/error', error.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-wrap {
  height: 100%;
  background-color: #f7fafc;
}

.login-navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  .logo {
    width: 120px;
    height: 40px;
    background-image: url('~@/assets/logo-adata.svg');
  }
}

.login {
  width: 460px;
  margin: 40px auto 40px auto;
  padding: 40px 80px;
  background-color: #fff;
}
</style>
